import * as React from 'react'
import {usePagination} from "react-instantsearch"
import {useTranslation} from "react-i18next"
import CommonUtils from "@bodeboca/utils"
import ApiService from "@bodeboca/api"

const CustomPagination = () => {
  const {
    isLastPage, pages, nbPages, refine, currentRefinement, createURL
  } = usePagination({})

  const {t} = useTranslation()

  function goTo(event: any, page: number) {
    event.preventDefault()
    CommonUtils.onStateChange()
    refine(page)
  }
  function customCreateUrl(page: number) {
    if (ApiService.isMainSection()) {
      return createURL(page)
    }

    return undefined
  }

  return (<>
    {nbPages > 1 && <nav className={'pager'}>
      <ul className="pager__items js-pager__items">
        {currentRefinement !== 0 &&
          <li
            className="pager__item pager__item--first"
            onClick={(event) => {
              goTo(event, 0)
            }}>
            <a>{'<<'} {t('First')}</a>
          </li>}
        {currentRefinement !== 0 &&
          <li
            className="pager__item pager__item--first"
            onClick={(event) => {
              goTo(event, (currentRefinement - 1))
            }}>
            <a>{'<'} {t('Previous')}</a>
          </li>}
        {pages.map((page) => (<li
          className={"pager__item " + (page === currentRefinement ? 'is-active' : '')}
          key={page}
          onClick={(event) => {
            goTo(event, page)
          }}>
          <a href={customCreateUrl(page)}>
            {page + 1}
          </a>
        </li>

        ))}
        {!isLastPage && <li
          className="pager__item pager__item--first"
          onClick={(event) => {
            goTo(event, currentRefinement + 1)
          }}>
          <a>{t('Next')} {'>'}</a>
        </li>}
        {!isLastPage && <li
          className="pager__item pager__item--first"
          onClick={(event) => {
            goTo(event, (nbPages - 1))
          }}>
          <a>{t('Last')} {'>>'}</a>
        </li>}
      </ul>
    </nav>}
  </>)
}
export default CustomPagination
